export enum PaymentFrequency {
	Monthly = 'Monthly',
	Annually = 'Annual',
}
